import { t } from "../i18n/index.js";
import { escapeHtml } from "./shell.js";

export function formatBytes(n: number): string {
  if (n < 1024) return t("bytes.B", { n });
  if (n < 1024 * 1024) return t("bytes.KB", { n: Math.round(n / 1024) });
  if (n < 1024 * 1024 * 1024) return t("bytes.MB", { n: Math.round(n / (1024 * 1024)) });
  return t("bytes.GB", { n: (n / (1024 * 1024 * 1024)).toFixed(1) });
}

export function formatDuration(seconds: number): string {
  if (seconds < 60) return t("time.seconds", { n: Math.max(0, Math.round(seconds)) });
  if (seconds < 3600) return t("time.minutes", { n: Math.round(seconds / 60) });
  if (seconds < 86_400) return t("time.hours", { n: Math.round(seconds / 3600) });
  return t("time.days", { n: Math.round(seconds / 86_400) });
}

export function formatBytesOrUnlimited(n: number): string {
  if (!n || n <= 0) return t("common.unlimited");
  return formatBytes(n);
}

export function formatDurationOrUnlimited(seconds: number): string {
  if (!seconds || seconds <= 0) return t("common.unlimited");
  const years = seconds / (365 * 86400);
  if (years >= 1) return t(years >= 2 ? "time.years" : "time.year_n", { n: Math.round(years * 10) / 10 });
  const months = seconds / (30 * 86400);
  if (months >= 1) return t(months >= 2 ? "time.months" : "time.month_n", { n: Math.round(months * 10) / 10 });
  return formatDuration(seconds);
}

export function formatRelativeDate(iso: string | Date): string {
  const ts = typeof iso === "string" ? new Date(iso).getTime() : iso.getTime();
  const diff = Math.max(0, Date.now() - ts);
  const m = Math.round(diff / 60_000);
  if (m < 1) return t("notifications.time.just_now");
  if (m < 60) return t("notifications.time.minutes_ago", { n: m });
  const h = Math.round(m / 60);
  if (h < 24) return t("notifications.time.hours_ago", { n: h });
  const days = Math.round(h / 24);
  if (days < 7) return t("notifications.time.days_ago", { n: days });
  return new Date(ts).toLocaleDateString();
}

export function formatAbsoluteDate(iso: string | Date): string {
  const d = typeof iso === "string" ? new Date(iso) : iso;
  return d.toLocaleString();
}

export function renderRelativeDate(iso: string | Date): string {
  const rel = formatRelativeDate(iso);
  const abs = formatAbsoluteDate(iso);
  return `<span data-tip="${escapeHtml(abs)}">${escapeHtml(rel)}</span>`;
}
